import queryString from "query-string"
import { replace } from "redux-first-history"
import { put, select } from "redux-saga/effects"

export default function* updateFilter() {
  const state = yield select()
  const { search } = state.router.location
  const queryParams = search
    ? queryString.parse(search, { arrayFormat: "bracket" })
    : {}

  const activeFilters = state.collection.filters
    .reduce(
      (accu, filter) => [
        ...accu,
        ...filter.categories
          .filter((cat) => cat.is_active_filter)
          .reduce((params, cat) => [...params, ...cat.filter_param], []),
      ],
      []
    )
    .sort()
  const currentSort = state.collection.sort

  const filteredParams = {
    ...Object.fromEntries(
      Object.entries(queryParams).filter(
        ([key]) => !["filtered_tags", "new_sort", "sort"].includes(key)
      )
    ),
    ...(activeFilters?.length > 0 && { filtered_tags: activeFilters }),
    ...(currentSort && currentSort !== "featured" && { sort: currentSort }),
  }

  yield put(
    replace({
      search: queryString.stringify(filteredParams, {
        arrayFormat: "bracket",
      }),
    })
  )
}
